import React, {Component} from 'react';
import $ from 'jquery';
import StaticHeader from "./StaticHeader";
import {Link, NavLink, Redirect} from "react-router-dom";
import {authService} from "./auth";
import "../src/profile/container/profile/css/main-profile.min.css";
import "../src/project/container/Project/css/main-projects.min.css";
import axios from "axios";
import IndividualProfileByPass from "./IndividualProfileByPass";
import BusinessProfileByPass from "./BusinessProfileByPass";
import DeactivatedUnAuthProfile from './profile/container/profile/DeactivatedUnAuthProfile';
import { pageClickHookPostMethod } from './services/PostApi';

class ProfileByPass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated(),
            userDetails: {},
            sharingConfig: {},
            privacySetting:{},
            pathname:'',
            unavailableFlag: this.props.match.params.customUrl !== "unavailable" ? false : true
        }

    }

    handleLoginClose = () => {
        this.setState({'loginRequired': false})
        window.$('#loginModal').modal('hide');
    }

    componentDidMount() {
            
        window.$(".unauthLoginPopclose").click(function(){
            window.$(".bkbackdrop2").hide();
        });

        window.$('#header .iCross').hide();
        window.$("#header .iHamburger").on('click', function (event) {
            window.$('.leftpanel').addClass('navactive');
            window.$('.dgcontainer').addClass('navactive');
            window.$('.staticPage').addClass('navactive');
            window.$('#header .iHamburger').hide();
            window.$('#header .iCross').show();
        });
        $("body, html").on('click', function (event) {
            if (!$(event.target).closest('#header .iHamburger, .read-more-less-btn').length) {
                $('.leftpanel').removeClass('navactive');
                $('.dgcontainer').removeClass('navactive');
                window.$('.staticPage').removeClass('navactive');
                $('.dropdown-menu.show').removeClass('show');
                window.$('#header .iHamburger').show();
                window.$('#header .iCross').hide();
            }
        });
        window.$('.usermenu .dropdown-submenu > a').on("click", function (e) {
            var submenu = $(this);
            $('.usermenu .dropdown-submenu .dropdown-menu').removeClass('show');
            submenu.next('.usermenu .dropdown-menu').addClass('show');
            e.stopPropagation();
        });

        if(!this.state.unavailableFlag) {
            this.getProfileData();
        }
    }

    sanitize(url) {
        let PROTOCOL_WHITELIST = ['http://', 'https://'];
        if (url) {
            for (let i = 0; i < PROTOCOL_WHITELIST.length; i++)
                if (url.startsWith(PROTOCOL_WHITELIST[i]))
                    return url;
            return 'http://' + url
        }
        return url;
    }



    getProfileData = () => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_userServiceURL}/unauth/userData?customUrl=${this.props.match.params.customUrl}`,
            headers: {"Content-Type": "application/json"},
            withCredentials: true,
        }).then((response) => {
            let res = response.data;
            this.handlePageClickHookPost(response.data.body?.id);
            if (res && res.status === '200 OK') {
                this.setState({
                    userDetails: res.body
                })
            }
        }).catch((err) => {
            console.log(err);
            if(err.response && err.response.status === 410) {
                this.setState({
                    unavailableFlag: true
                })
            }
        });
    }

    handlePageClickHookPost = async (userId) => {
        let postData = {
          entityId: userId,
          userId: null,
          entityType: "USER"
        }
        await pageClickHookPostMethod(postData);
    }

    redirect () {
        if(this.state.userDetails &&
            this.state.userDetails.type === "INDIVIDUAL"){
            return (<IndividualProfileByPass userDetails={this.state.userDetails}
            customUrl={this.props.match.params.customUrl}/>)
        }else if(this.state.userDetails &&
            this.state.userDetails.type === "COMPANY"){
            return (<BusinessProfileByPass userDetails={this.state.userDetails}
                                           customUrl={this.props.match.params.customUrl}/>)
        }
    }

    redirectToDeactivation = (event) => {
        (this.props.history.push({
            pathname: '/unavailable',
            state: {
                customUrl:this.props.match.params.customUrl,
            }
        }))
    }
    render() {
        const parent = {height: '19px'}

        if (this.state.unavailableFlag || (this.state.userDetails && this.state.userDetails.deactivated)) {
            return (
                <DeactivatedUnAuthProfile {...this.props} />
            )
        } else{

            return (<div> {this.redirect()}</div>
        );}
    }
}

export default ProfileByPass;
